import $ from 'jquery'
import { alert_error, post_json, get_json, eval_html_template,
         get_myinfo, has_user_loggedin, alert_message_html } from '../../common'
import * as qs from 'querystring'

$(init)

async function init () {
  let $page = $('#order-page')
  if ($page.length == 0) {
    return
  }
  try {
    window.__fakesale = () => {
      onPurchaseSuccess()
    }
    let myinfo = await get_myinfo()
    let loggedin = has_user_loggedin(myinfo)
    if (!loggedin) {
      $page.find('.loading-indicator').addClass('d-none')
      return
    }
    let query = qs.parse(location.search.substr(1))
    let order_id = query.id
    if (!order_id) {
      throw new Error('id is not defined!')
    }
    let order = (await get_json(`/premium/get-order/${order_id}`)).data
    if (!order.plan && !order.custom_price) {
      throw new Error('Order package has not found!')
    }
    $page.find('.loading-indicator').addClass('d-none')
    if (!order) {
      $page.find('.order-not-found').removeClass('d-none')
      return
    }
    let $order = $page.find('.order')
    $order.html('')
    eval_html_template('#order-template', order, $order[0])
    $order.removeClass('d-none')
    if (order.did_capture) {
      $page.find('.payment-completed').removeClass('d-none')
      return
    }
    if (!window.paypal) {
      alert_error({ message: 'Paypal script has not loaded, Page refresh may help' })
      return
    }
    paypal.Buttons({
      createOrder (data, actions) {
        return Promise.resolve(order.paypal_order_id)
      },
      async onError (error) {
        if ((error+'').indexOf('PAYMENT_ALREADY_DONE') != -1) {
          alert_error({ message: 'Could not capture the payment as expected. Please contact support for help.' })
        }
      },
      async onApprove (data, actions) {
        try {
          $page.find('.loading-indicator').removeClass('d-none')
          await post_json('/premium/paypal-capture-order', {
            paypal_order_id: data.orderID,
          })
          $page.find('.loading-indicator').addClass('d-none')
          if (!order.plan && !(order.custom_listings > 0)) {
            alert_message_html('Order has completed', `
<p class="p-3">Feel free to contact us for receiving updates.</p>
`)
          } else {
            onPurchaseSuccess()
          }
        } catch (err) {
          alert_error(err)          
        }
      },
    }).render('#paypal-button-render-wrp')
  } catch (err) {
    $page.find('.loading-indicator').addClass('d-none')
    alert_error(err)
  }
}

function onPurchaseSuccess () {
  let $modal = alert_message_html('Order has completed', `
<p class="p-3">Enjoy using your package in ResellKit now, <a href="/premium/active-plans/">See active packages</a></p>
`)
  $modal.on('hide.bs.modal', () => {
    window.location = '/premium/active-plans/'
  })
}
